// extracted by mini-css-extract-plugin
export default {"triangle":"SelectTriangle_triangle__Baxad","up":"SelectTriangle_up__-zAw9","down":"SelectTriangle_down__gvDJ6"};